/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCopiedProjectFieldDto } from '../../models/backend-copied-project-field-dto';

export interface ProjectsCopiedProjectRetrieve$Params {
  id: number;
}

export function projectsCopiedProjectRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsCopiedProjectRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsCopiedProjectRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCopiedProjectFieldDto>;
    }),
  );
}

projectsCopiedProjectRetrieve.PATH = '/api/projects/copied_project/{id}/';
